import React, { useContext, useEffect } from "react";
import { ManagerContext } from "../../contexts/ManagerProvider";
import { useNavigate } from "react-router-dom";
import { fetchUserAttributes } from "aws-amplify/auth";

const LoginGuardContext = React.createContext<() => void>(() => {
})

export function withLoginGuard(Component: React.ComponentType): React.FunctionComponent {
  return (props) => {
    const [manager, setManager, signOut] = useContext(ManagerContext)

    const navigate = useNavigate()

    useEffect(() => {
      if (!manager) {
        navigate('/login')
      } else {
        if (manager.needsNewPassword) {
          navigate('/auth/new-password-required')
          return
        }

        if (!manager.attributes) {
          fetchUserAttributes()
            .then((attrs) => {
              setManager({
                ...manager,
                attributes: {
                  email: attrs.email ?? '',
                  sub: attrs.sub ?? manager.userId,
                },
              })
            })
            .catch((err) => {
              console.log('getUserAttributes')
              console.log(err)
            })
        }
      }
    }, [manager, navigate])

    async function signOutAndNavigateToLogin() {
      await signOut()
      navigate('/login')
    }

    if (!manager || !manager.isApiChecked) return <div/>

    return (
      <LoginGuardContext.Provider value={signOutAndNavigateToLogin}>
        <Component {...props} />
      </LoginGuardContext.Provider>
    )
  }
}

export function useSignOut(): () => void {
  return useContext(LoginGuardContext)
}
